import React, { useState, useEffect } from "react";
import myOwnlast from "../../images/myOwnlast.png";
import { Title } from "../Title";
import { TextAbout } from "./TextAbout";
import { Details } from "./Details";
import { WhatsApp } from "./WhatsApp";
import { FaWhatsapp } from "react-icons/fa";
import MyCv from "./cv/ShawnCv.pdf";
import { CustomizedSnackbars } from "../../MUI/MuiComponent";
import "./about.css";

export const About = () => {
  const [isWhatsAppQRCodeOpen, setisWhatsAppQRCodeOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  useEffect(() => {
    const autoTime = setTimeout(() => {
      setIsClicked(false);
    }, 6000);
    return () => {
      clearTimeout(autoTime);
    }
  }, [isClicked]);
  return (
    <>
      <div className="about-flex">
        <div className="box-imgae">
          <div className="img-golden-border" data-aos="fade-right">
            <img src={myOwnlast} alt="shawnpictue" className="my-about-pic" />
          </div>
        </div>
        <div className="about-text-content">
          <Title title="About Me" />
          <TextAbout />

          {/* my button container */}

          <div className="about-button-container">
            <CustomizedSnackbars btnText="Download CV" downloadImg={MyCv} downloadNoti="CV is downlaoding...."/>
            <button
              onClick={() => {
                setisWhatsAppQRCodeOpen(true);
                setIsClicked(true);
              }}
              className="about-buttons"
            >
              Make a Call
              <FaWhatsapp />
            </button>
          </div>

          <WhatsApp
            isWhatsAppQRCodeOpen={isWhatsAppQRCodeOpen}
            setisWhatsAppQRCodeOpen={setisWhatsAppQRCodeOpen}
            isClicked={isClicked}
            setIsClicked={setIsClicked}
          />
        </div>
      </div>
      <Details />
    </>
  );
};
